import { render } from "./card5.vue?vue&type=template&id=6e47a1b4&scoped=true"
const script = {}

import "./card5.vue?vue&type=style&index=0&id=6e47a1b4&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e47a1b4"]])

export default __exports__